import apiClient from "@/lib/apiClient";
import React, { useRef, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const CategoryScroll = () => {
  const scrollRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [networks, setNetworks] = useState([]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollAmount = 0;
    const scrollSpeed = 0.5;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;

    const scroll = () => {
      if (!scrollContainer) return;

      scrollAmount += scrollSpeed;
      if (scrollAmount >= maxScroll) {
        scrollAmount = 0;
      }

      scrollContainer.scrollLeft = scrollAmount;
      animationId = requestAnimationFrame(scroll);
    };

    let animationId = requestAnimationFrame(scroll);

    const handleInteraction = () => {
      cancelAnimationFrame(animationId);
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(() => {
        scrollAmount = scrollContainer.scrollLeft;
        animationId = requestAnimationFrame(scroll);
      }, 3000);
    };

    let resumeTimeout;

    scrollContainer.addEventListener("mouseenter", handleInteraction);
    scrollContainer.addEventListener("touchstart", handleInteraction);
    scrollContainer.addEventListener("scroll", handleInteraction);

    return () => {
      cancelAnimationFrame(animationId);
      clearTimeout(resumeTimeout);
      scrollContainer.removeEventListener("mouseenter", handleInteraction);
      scrollContainer.removeEventListener("touchstart", handleInteraction);
      scrollContainer.removeEventListener("scroll", handleInteraction);
    };
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setIsLoading(true);
      
      const { ok, data } = await apiClient.get("/channels/all");
      setIsLoading(false);

      if (ok) setNetworks(data.channels);
    } catch (error) {
      toast.error("مشکلی درگرفتن شبکه ها به وجود امده است");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white border-t border-gray-200 relative">
      <div className="container-custom py-1 sm:py-2 relative">
        <div
          ref={scrollRef}
          className="flex gap-2 sm:gap-4 pb-1 sm:pb-2 overflow-x-auto no-scrollbar carousel"
        >
          {isLoading
            ? Array(8)
                .fill(0)
                .map((_, index) => (
                  <div key={index} className="category-card flex-shrink-0">
                    <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full shimmer"></div>
                    <div className="w-12 h-2 mt-1 shimmer rounded"></div>
                  </div>
                ))
            : networks?.map((network) => (
                <Link
                  key={network.id}
                  to={network.id === "home" ? "/" : `/networks/${network.id}`}
                  className="category-card flex-shrink-0"
                >
                  <div className="category-icon flex justify-center">
                    <img
                      src={`${
                        import.meta.env.VITE_WEBSITE_URL
                      }/uploads/channel/${network.image}`}
                      alt={network.title}
                      className="w-10 h-10 sm:w-14 sm:h-14 object-cover border rounded-full border-green-100"
                    />
                  </div>
                  <span className="text-[9px] sm:text-xs w-full  text-center whitespace-nowrap overflow-hidden text-ellipsis">
                    {network.title}
                  </span>
                </Link>
              ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryScroll;
